import React from 'react'

export default function ChildrensServices() {
    return (
        <div>
            <p className="mainFont" style={{ fontSize: '1.25em' }}>
                            Children's Services
                    </p>
                        <hr />
                        <p className="mainFont" style={{ fontSize: '1em' }}>
                            School Based Services
                            School Based Behavioral Health (SBBH)
                            The SBBH (School Based Behavioral Health) Program provides a variety of school based behavioral health
                            and educational support services to students, identified through their Individual Educational Plans (IEP), as
                            being in need of such services. These services are provided in an effort to increase the student's ability to
                            benefit from their education. Those providing services include psychologists, and masters level clinicians.
                    </p>
                        <p className="mainFont" style={{ fontSize: '1em', fontWeight: '600' }}>These services include:</p>
                        <ul className="mainFont" style={{ fontSize: '1em' }}>
                            <li>
                                Individual and Group Counseling
                        </li>
                            <li>
                                Parent/Family Counseling and Training
                        </li>
                            <li>
                                Educational Planning
                        </li>
                        </ul>
                        <p className="mainFont" style={{ fontSize: '1.25em' }}>
                            Behavioral Instructional Support Services
                    </p>
                        <hr />
                        <p className="mainFont" style={{ fontSize: '1em' }}>
                            This service is provided for students who have been identified as having a developmental delay and/or
                            disability, or behaviors that significantly impair the student’s educational progress. This service is an
                            intensive service provided by Master or Doctoral Level clinicians. The purpose of the service is to promote
                            student growth toward meeting identified educational goals. The clinician develops the student’s monthly
                            service plan and the functional behavior assessment/behavior support plan and assists education personnel in
                            leading and implementing activities of support staff to carry out the educational plan. The clinician also
                            assists in the collection and analysis of data indicating the student’s response to interventions. These services
                            are provided at the direction of the student’s Individual Educational Plan.
                    </p>
                
                        <p className="mainFont" style={{ fontSize: '1.25em' }}>
                            Paraprofessional Support Services
                    </p>
                        <hr />
                        <p className="mainFont" style={{ fontSize: '1em' }}>
                            This service is provided for students who have been identified as having a developmental delay and/or
                            disability, or behaviors that significantly impair the student’s educational progress Paraprofessional skills
                            trainers are trained to implement behavior interventions and work with the student in the classroom setting.
                            Services are delivered to students either individually or in a group format to implement the behavior support
                            plan. Data is collected on a daily basis to continuously inform the provision of services. The ultimate goal
                            of paraprofessional services is to develop the student’s ability to function in a less restrictive environment
                            with more natural supports. These services are provided at the direction of the student’s Individual
                            Educational Plan.
                    </p>
       
                        <p className="mainFont" style={{ fontSize: '1.25em' }}>
                            Early Intervention (0-3)
                    </p>
                        <hr />
                        <p className="mainFont" style={{ fontSize: '1em' }}>
                            Children, up to age 3, who have developmental delays (cognition, speech, language, physical, motor, vision,
                            hearing) as well as all children identified with an Autism Spectrum Disorder are eligible to receive IBS
                            services in addition to the developmental services they may already be receiving. are eligible for early
                            intervention services. The frequency and intensity of services provided to children are based upon
                            recommendations of the therapists and the agreement of the Individualized Family Support Plan (IFSP)
                            Team, which includes the parents. Developmental therapy services, including IBS services, can be provided
                            in the family's home, the child’s preschool or day care, or at the Early Intervention program.
                    </p>
                        <br />
        </div>
    )
}
